import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { User, LoginCredentials } from '@/types'

export const useAuthStore = defineStore('auth', function() {
  const user = ref<User | null>(null)
  const token = ref<string | null>(sessionStorage.getItem('authToken'))
  
  const isAuthenticated = computed(function() { 
    return !!token.value && !!user.value 
  })
  
  const login = function(credentials: LoginCredentials) {
    return new Promise(function(resolve, reject) {
      // 管理员登录，必须使用后端
      if (credentials.email === 'admin@ahair.net' && credentials.password === 'admin123') {
        fetch('/api/auth/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(credentials),
        })
        .then(function(response) {
          if (response.ok) {
            return response.json()
          } else {
            console.error('后端认证失败:', response.status, response.statusText)
            return false
          }
        })
        .then(function(data) {
          if (data) {
            token.value = data.data.token
            // 解析 permissions 字段
            const userData = data.data.user
            console.log('登录返回的用户数据:', userData)
            console.log('原始 permissions:', userData?.permissions)
            if (userData && typeof userData.permissions === 'string') {
              try {
                userData.permissions = JSON.parse(userData.permissions)
                console.log('解析后的 permissions:', userData.permissions)
              } catch (e) {
                console.error('解析 permissions 失败:', e)
              }
            }
            user.value = userData
            sessionStorage.setItem('authToken', data.data.token)
            resolve(true)
          } else {
            resolve(false)
          }
        })
        .catch(function(backendError) {
          console.error('后端连接失败:', backendError)
          reject(new Error('无法连接到服务器，请检查后端服务是否正常运行'))
        })
        return
      }
      
      // 非管理员账号或普通登录，必须使用后端
      fetch('/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      })
      .then(function(response) {
        if (response.ok) {
          return response.json()
        }
        return false
      })
      .then(function(data) {
        if (data) {
          token.value = data.data.token
          // 解析 permissions 字段
          const userData = data.data.user
          if (userData && typeof userData.permissions === 'string') {
            try {
              userData.permissions = JSON.parse(userData.permissions)
            } catch (e) {
              console.error('解析 permissions 失败:', e)
            }
          }
          user.value = userData
          sessionStorage.setItem('authToken', data.data.token)
          resolve(true)
        } else {
          resolve(false)
        }
      })
      .catch(function(error) {
        console.error('Login failed:', error)
        reject(error)
      })
    })
  }
  
  const logout = function() {
    user.value = null
    token.value = null
    sessionStorage.removeItem('authToken')
  }
  
  const checkAuth = function() {
    return new Promise(function(resolve) {
      if (!token.value) {
        resolve(false)
        return
      }
      
      fetch('/api/auth/me', {
        headers: {
          'Authorization': 'Bearer ' + token.value,
        },
      })
      .then(function(response) {
        if (response.ok) {
          return response.json()
        } else {
          logout()
          return false
        }
      })
      .then(function(data) {
        if (data) {
          // 解析 permissions 字段
          const userData = data.data
          if (userData && typeof userData.permissions === 'string') {
            try {
              userData.permissions = JSON.parse(userData.permissions)
            } catch (e) {
              console.error('解析 permissions 失败:', e)
            }
          }
          user.value = userData
          resolve(true)
        } else {
          resolve(false)
        }
      })
      .catch(function(error) {
        console.error('检查认证状态失败:', error)
        logout()
        resolve(false)
      })
    })
  }
  
  const setMockAuth = function(mockUser: User | null, mockToken: string | null) {
    user.value = mockUser
    token.value = mockToken
  }
  
  return {
    user: user,
    token: token,
    isAuthenticated: isAuthenticated,
    login: login,
    logout: logout,
    checkAuth: checkAuth,
    setMockAuth: setMockAuth,
  }
})